import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IntegrationImportErrorsParams,
  IntegrationImportErrorResult,
  IntegrationImportParams,
  IntegrationImportResult
} from './integration-imports.interface';

@Injectable()
export class IntegrationsImportService {
  constructor(private http: HttpClient) {}

  fetch(params: IntegrationImportParams): Observable<IntegrationImportResult> {
    return this.http.post<IntegrationImportResult>('/integration/import/fetch', params);
  }

  fetchErrors(filter: IntegrationImportErrorsParams): Observable<IntegrationImportErrorResult> {
    return this.http.post<IntegrationImportErrorResult>('/integration/import/error/fetch', filter);
  }

  getPagerIndexReset(pager) {
    return pager ? { ...pager, pageIndex: 0 } : null;
  }
}
